import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { useNavigate } from 'react-router';
import './styles.scss'
import { chatSignup } from '../../../services/users';
import BeatLoader from "react-spinners/BeatLoader";
import Constant from "../../../Constant";
import { FaSignInAlt } from 'react-icons/fa';
import { APP_ENV, APP_URL } from '../../../constants';

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Enter a valid email address')
    .required('Email is required'),
  first_name: Yup.string()
    .required('Field is required'),
  userCountry: Yup.string()
    .required('Please select a country.'),
  role: Yup.string()
    .required('Please select a role.'),
  pin: Yup.number()
    .required('PIN is required')
    .min(5, 'PIN is too short - Should be 5 digits'),
  rePin: Yup.number()
    .required('PIN is required')
    .min(5, 'PIN is too short - Should be 5 digits')
});

const SignupChatForm = ({ idToken }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [country, setCountry] = useState("Cameroon");
  const [role, setRole] = useState("Personal");

  const handleSubmit = (values)=>{
    setIsLoading(true);
    try {
      chatSignup(values).then(res => {
        // console.log("signup result", res);
        if(res.status_code == 200 || res.status_code == '201')
          setSuccessMessage(res.message);
        else 
        setErrorMessage(res.message);
      }).catch(err => {
        console.log(`Error: ${err}`);
        setErrorMessage(err.message);
      }).finally( () => setIsLoading(false));
    } catch (err) {
      console.log('########### signup error', err);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    // console.log('loading languages', APP_URL);
    //TODO Get language from idToken
  }, []);

  return  (
    <div className="login-form">Complete your Signup
      <div className="login-error">
        <p className='text-color-red'>{ errorMessage ? errorMessage : ''}</p>
      {
      errorMessage && 
      <button type="button" onClick={() => navigate(0)} className='font-bold text-xl text-color-red' >
          Try again
      </button>
      }
      </div>
      <div className="login-success">
        <p className='font-bold'>{ successMessage ? successMessage : ''}</p>
        {
        successMessage && 
        <button type="button" onClick={() => window.location.replace('https://aftawallet.com')} className='font-bold text-xl' style={{ color: '#405B9C'}} >
            <span>Continue</span>
        </button>
        }
      </div>
      
      {
      errorMessage == '' && successMessage == '' &&
      <Formik
        initialValues={{
          email: "",
          first_name: "",
          userCountry: country,
          role: role,
          pin: '',
          rePin: '',
          id: idToken,
        }}
        onSubmit={(values) => {
          values.confirm_pin = Number(values.rePin);
          values.pin = Number(values.pin);
          values.country = country;
          handleSubmit(values);
        }}
        validationSchema={validationSchema}
      >
        {({ handleSubmit, values, handleChange, errors, touched }) => (

          <form onSubmit={handleSubmit}>
            
            <div className={`field`}>
              <label htmlFor="first_name">Full Name*</label>
              <input
                name="first_name"
                id="first_name"
                placeholder="Enter First name"
                value={values.first_name}
                onChange={handleChange}
              />
              {errors.first_name && touched.first_name ? (
                <div className="error">{errors.first_name}</div>
              ) : null}
            </div>
            <div className={`field`}>
              <label htmlFor="email">Email*</label>
              <input
                name="email"
                id="email"
                placeholder="Enter Email"
                value={values.email}
                onChange={handleChange}
              />
              {errors.email && touched.email ? (
                <div className="error">{errors.email}</div>
              ) : null}
            </div>
            
            {/* <div className={`field`}>
              <label htmlFor="phone_number">Phone Number* (Whatsapp)</label>
              <input
                name="phone_number"
                id="phone_number"
                placeholder="Enter Phone number (Whatsapp)"
                value={values.phone_number}
                onChange={handleChange}
              />
              {errors.phone_number && touched.phone_number ? (
                <div className="error">{errors.phone_number}</div>
              ) : null}
            </div> */}
            <div className={`field`}>
              <label htmlFor="userCountry">Select Country</label>
              <select 
                name={`userCountry`}
                id={`userCountry`} 
                value={country} 
                onChange={event => setCountry(event.target.value)} 
                className="__form-input">
                  <option value="Cameroon">Cameroon</option>
                  <option value="Rwanda">Rwanda</option>
                  <option value="Kenya">Kenya</option>
                  {/* <option value="Ivory Coast">Ivory Coast</option>
                  <option value="Kenya">Kenya</option>
                  <option value="Nigeria">Nigeria</option>
                  <option value="Ghana">Ghana</option>
                  <option value="Zimbabwe">Zimbabwe</option>
                  <option value="Congo Brazza">Congo Brazzavile</option>
                  <option value="Tchad">Tchad</option>
                  <option value="Senegal">Senegal</option>
                  <option value="Mali">Mali</option>
                  <option value="Togo">Togo</option>
                  <option value="Benin">Benin</option>
                  <option value="Zambia">Zambia</option> */}
              </select>
              {errors.userCountry && touched.userCountry ? (
                <div className="error">{errors.userCountry}</div>
                ) : null
              }
            </div>
            <div className={`field`}>
              <label htmlFor="role">Account type</label>
              <select 
                name={`role`}
                id={`role`} 
                value={role} 
                onChange={event => setRole(event.target.value)} 
                className="__form-input">
                  <option value="Personal">Personal</option>
                  <option value="Agent">Agent</option>
                  <option value="Merchant">Merchant</option>
              </select>
              {errors.role && touched.role ? (
                <div className="error">{errors.role}</div>
                ) : null
              }
            </div>
            <div className={`field`}>
              <label htmlFor="pin">PIN*</label>
              <input
                name="pin"
                id="pin"
                type="password"
                placeholder="Enter PIN"
                value={values.pin}
                maxLength={5}
                minLength={5}
                onChange={handleChange}
              />

              {errors.pin && touched.pin ? (
                <div className="error">{errors.pin}</div>
              ) : null}
            </div>
            <div className={`field`}>
              <label htmlFor="rePin">Confirm PIN*</label>
              <input
                name="rePin"
                id="rePin"
                type="password"
                placeholder="Confirm PIN"
                value={values.rePin}
                onChange={handleChange}
                maxLength={5}
                minLength={5}
              />
              {errors.rePin && touched.rePin ? (
                <div className="error">{errors.rePin}</div>
              ) : null}
            </div>
            <button type="submit" disabled={isLoading}>
            {!isLoading && <span>Signup</span>} &nbsp;<FaSignInAlt />{!isLoading && <span> </span>}
            </button>
            {isLoading && <span>Signing up. Please wait ...</span>}
            <BeatLoader
                color={Constant.spinner_color}
                loading={isLoading}
                cssOverride={{
                  textAlign: 'center',
                  marginTop: '20px'
                }}
              />
          </form>
        )
        }
      </Formik>
      }
    </div>
  );
};

export default SignupChatForm;
